"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KebabMenuItem = KebabMenuItem;

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@eig-builder/core-ui/MenuItem"));

var _ListItemIcon = _interopRequireDefault(require("@eig-builder/core-ui/ListItemIcon"));

var _moduleLocalization = _interopRequireDefault(require("@eig-builder/module-localization"));

var _Icon = _interopRequireDefault(require("@eig-builder/core-ui/Icon"));

var _isString = _interopRequireDefault(require("lodash/isString"));

function KebabMenuItem(kebabItems, kebabId, closeFn) {
  return kebabItems.map(function (item) {
    var id = item.id,
        icon = item.icon,
        displayName = item.displayName,
        fn = item["function"];
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: id,
      value: id,
      onClick: function onClick() {
        fn(kebabId);
        closeFn();
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, (0, _isString["default"])(icon) ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      icon: icon
    }) : icon), /*#__PURE__*/_react["default"].createElement(_moduleLocalization["default"], {
      message: displayName
    }));
  });
}